import { render, staticRenderFns } from "./URLInput.vue?vue&type=template&id=ef2965fa&lang=pug&"
import script from "./URLInput.vue?vue&type=script&lang=js&"
export * from "./URLInput.vue?vue&type=script&lang=js&"
import style0 from "./URLInput.vue?vue&type=style&index=0&id=ef2965fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports